import React from "react";
import PropTypes from "prop-types";
import FieldTable from "./FieldTable.component.jsx";
import {flattenProperties} from "./properties.js";

/**
 * The fields of one side's response, for a run with no comparison to read them out of - a
 * single-sided operation like /me or /startup, or a pair where one side did not answer 200.
 *
 * Every item is listed in full, like the raw body next to it: the page is the only scroll region,
 * so nothing here truncates.
 */
export default function Properties({items}) {
    if (items == null || items.length === 0) {
        return null;
    }

    /*
     * One table rather than one per item: several items index their paths ([0].uid, [1].uid) the way
     * the flattener already indexes a nested array, which keeps every row's field unique.
     */
    const entries = items.length === 1
        ? flattenProperties(items[0])
        : items.flatMap((item, index) => flattenProperties(item, `[${index}]`));

    return (
        <details open>
            <summary>Properties</summary>
            <FieldTable
                valueHeader="Value"
                rows={entries.map(entry => ({field: entry.path, value: entry.value}))}
            />
        </details>
    );
}

Properties.propTypes = {
    // what the side's `extract(body)` returned: always an array, so a single object reads like a list
    items: PropTypes.array,
};
